import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead } from "../../components/admin/AdminBits";
import { Mail, Trash2, Check, Palette, MessageSquare } from "lucide-react";
import { toast } from "sonner";

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/inquiries").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.put(`/admin/inquiries/${id}`, { read: true }); load(); };
  const del = async (id) => { await api.delete(`/admin/inquiries/${id}`); load(); };

  return (
    <div data-testid="admin-inquiries">
      <PageHead title="Запитвания" desc="Запитвания от сайта (контакт и портрети). Прочетените се изтриват автоматично след 7 дни, но имейлите се запазват в базата с клиенти." />
      <div className="space-y-3">
        {items.length === 0 && <p className="text-charcoal/50">Няма запитвания.</p>}
        {items.map((i) => (
          <div key={i.id} className={`bg-white border p-5 ${i.read ? "border-stone" : "border-gold"}`} data-testid={`inquiry-${i.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  {i.type === "portrait" ? <Palette size={15} className="text-gold" /> : <MessageSquare size={15} className="text-gold" />}
                  <span className="font-serif text-lg text-navy">{i.name}</span>
                  <span className="text-xs px-2 py-0.5 bg-stone text-navy">{i.type === "portrait" ? "Портрет" : "Общо"}</span>
                  {!i.read && <span className="text-xs px-2 py-0.5 bg-gold text-white">Ново</span>}
                </div>
                <p className="text-sm text-charcoal/60 flex items-center gap-3"><span className="flex items-center gap-1"><Mail size={12} />{i.email || "—"}</span>{i.phone && <span>{i.phone}</span>}</p>
                <p className="text-charcoal/80 mt-2">{i.message}</p>
              </div>
              <div className="flex gap-2 shrink-0">
                {!i.read && <button onClick={() => markRead(i.id)} className="p-2 text-green-600 hover:bg-green-50 rounded" title="Прочетено" data-testid={`read-${i.id}`}><Check size={16} /></button>}
                <button onClick={() => del(i.id)} className="p-2 text-charcoal/40 hover:text-red-500 rounded"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
